// extracted by mini-css-extract-plugin
export var smallSpinner = "_ws-0";